import { Outlet, useNavigate } from "react-router";
import { useApp } from "../Context";
import { useEffect } from "react";

export default function AuthRouter(){
    const {auth, getCfg} = useApp();
    const navigate = useNavigate()

    async function checkAuth(){
        const {uid} = await getCfg()
        const stored = JSON.parse(localStorage.getItem("orderids")) || {};
        const restStored = stored[uid] ?? []

        if (!auth && restStored.length === 0) {
            navigate("login")
        }
    }

    useEffect(() => {
        checkAuth()
    },[auth, navigate])

    return <Outlet/>
}
